import { makeStyles } from '@material-ui/core/styles';

const useStyles = (theme) => ({
  container: {
    gap: theme.spacing(2)
  },
  link: {
    alignItems: 'center',
    fontSize: theme.spacing(4),
    cursor: 'pointer',
    fontWeight: 500,
    color: theme.colors.action_text,
    paddingLeft: 0
  },
  disabled: {
    opacity: '50%',
    cursor: 'unset'
  },
  tooltip: {
    paddingLeft: 0,
    marginBottom: theme.spacing(1)
  },
  pencilIcon: {
    marginLeft: theme.spacing(1),
    marginBottom: theme.spacing(1.5)
  }
});

export default makeStyles(useStyles);
